/*---------------State Management-----------------*/
import { makeAutoObservable, runInAction } from "mobx";

/*---------------API Client-----------------------*/
import agent from "../api/agent";

/*---------------Types & Models-------------------*/
import {
  DailyMetrics,
  DashboardData,
  Metrics,
  PreviousMonthMetrics,
} from "../models/Dashboard";


export default class DashboardStore {
  topDashboardData: DashboardData = {
    salesTargetData: null,
    weeklyOrderData: [],
    monthlyProductData: [],
  };
  topDashboardLoading: boolean = false;

  dailyMetrics: DailyMetrics = {
    todayData: {},
    yesterdayData: {},
  };

  dailyMetricsLoading: boolean = false;

  currentMonthMetrics: Metrics | {} = {};

  prevMonthMetrics: PreviousMonthMetrics = {
    productData: [],
    customerData: [],
  };

  constructor() {
    makeAutoObservable(this);
  }

  fetchTopDashboardData = async () => {
    this.setTopDashboardLoading(true);
    try {
      const response = await agent.Dashboard.getTopDashboardItems();
      runInAction(() => {
        this.topDashboardData = response.data;
      });
    } catch (error) {
    } finally {
      this.setTopDashboardLoading(false);
    }
  };

  fetchDailyMetrics = async () => {
    this.setDailyMetricsLoading(true);
    try {
      const response = await agent.Dashboard.getDailyMetrics();
      runInAction(() => {
        if(response.data){
            this.dailyMetrics = response.data;
        }  
      });
    } catch (error) {
    } finally {
      this.setDailyMetricsLoading(false);
    }
  };

  fetchCurrentMonthMetrics = async () => {
    try {
      const response = await agent.Dashboard.getCurrentMonthMetrics();
      runInAction(() => {
        this.currentMonthMetrics = response.data;
      });
    } catch (error) {}
  };

  fetchPreviousMonthMetrics = async () => {
    try {
      const response = await agent.Dashboard.getPrevMonthMetrics();
      runInAction(() => {
        this.prevMonthMetrics = response.data;
      });
    } catch (error) {}
  };

  setTopDashboardLoading = (value: boolean) => {
    this.topDashboardLoading = value;
  };

  setDailyMetricsLoading = (value: boolean) => {
    this.dailyMetricsLoading = value;
  };

}
